/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
/**
 * @description: 销售合同
 * @return {*}
 * @author: 胡彩丽 hucaili@qfei.cn
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const CONTRACT = {
  path: '/contract',
  name: 'contract',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'contract-list' },
  meta: {
    title: '销售合同',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'contract',
    order: 4
  },
  children: [
    {
      path: 'index',
      name: 'contract-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'contract-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'contract:view',
        title: '销售合同管理'
      },
      children: [
        {
          path: '',
          name: 'contract-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 8 },
          meta: {
            requiresAuth: true,
            roles: 'contract:view',
            title: '销售合同管理'
          }
        },
        {
          path: ':id/collaborators',
          name: 'contract-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 8 },
          meta: {
            requiresAuth: true,
            title: '销售合同详情',
            roles: 'contract:view'
          }
        },
        {
          path: ':id',
          name: 'contract-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 8 },
          meta: {
            requiresAuth: true,
            title: '销售合同详情',
            roles: 'contract:view'
          }
        }
      ]
    }
  ]
};

export default CONTRACT;
